import {
  Checkbox,
  Input,
  InputNumber,
  message,
  Modal,
  notification,
  Spin,
  Tag,
} from "antd";
import requestService from "api/request";
import clsx from "clsx";
import { formatNumber } from "lib/helpers/format";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store";

const Invest = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const {t} = useTranslation()
  const { user } = useAppSelector((state) => state.app) as any;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [packSelecteds, setPackSelected] = useState<any>();
  const [time, setTime] = useState<number>(7);
  const [amount, setAmount] = useState<number>(packSelecteds?.min);
  const [point_type, setPoint_Type] = useState("");
  const [rate, setRate] = useState(0);
  const [histories, setHistories] = useState<Array<any>>([]);
  const [tabs, setTab] = useState<string>("INVEST");
  const dataCustom = {
    7: "7d",
    30: "30d",
    90: "90d",
    180: "180d",
    360: "360d",
  } as any;
  const getData = async () => {
    try {
      const res = await requestService.get("/guest/getInvest");
      if (res && res.data) {
        setData(res.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getHistories = async () => {
    try {
      const res = await requestService.get("/profile/getHistoryInvest", {
        params: {
          transaction_type: tabs,
        },
      });
      if (res && res.data) {
        setHistories(res.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getHistories();
  }, [tabs]);

  const handleBuyInvest = async () => {
    if (!user) return navigate("/login");
    setLoading(true);
    try {
      setOpen(false);
      const res = await requestService.post("/profile/handleBuyInvest", {
        data: {
          investId: packSelecteds?.id,
          amount,
          time,
          point_type,
          rate: packSelecteds?.rate?.[dataCustom[time]],

        },
      });
      if (res && res.data) {
        notification.success({
          message: "Đã mua gói đầu tư thành công",
          duration: 5,
        });
      }
    } catch (error: any) {
      notification.error({
        message: error?.response?.data?.message,
        duration: 5,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="max-w-[1280px]  mx-auto p-5">
      <Spin spinning={loading} fullscreen />
      <Modal
        open={open}
        footer={null}
        centered
        width={500}
        onCancel={() => {
          setOpen(false);
          setAmount(0);
          setTime(packSelecteds?.id === '1' ? 7 : 30);
        }}
      >
        <div className=" text-[#fff]">
          <h3 className="text-center text-[25px] font-[900] text-[#fff] mb-3">
            {t("Gói")} {packSelecteds?.id}
            <p>
              {packSelecteds?.min}$ - {packSelecteds?.max}$
            </p>
          </h3>
          <div className="mb-3 ">
            <label className="text-[14px] mb-3">
              {t("Chọn thời gian đầu tư")}
            </label>
            <div className="grid grid-cols-5 gap-3">
              {
                packSelecteds?.id === '1' &&
                <Tag
                  onClick={() => setTime(7)}
                  color={time === 7 ? "green-inverse" : ""}
                  className="text-center font-[700] cursor-pointer"
                >
                  7 {t("Ngày")}
                </Tag>
              }

              <Tag
                onClick={() => setTime(30)}
                color={time === 30 ? "green-inverse" : ""}
                className="text-center font-[700] cursor-pointer"
              >
                30 {t("Ngày")}
              </Tag>
              <Tag
                onClick={() => setTime(90)}
                color={time === 90 ? "green-inverse" : ""}
                className="text-center font-[700] cursor-pointer"
              >
                90 {t("Ngày")}
              </Tag>
              <Tag
                onClick={() => setTime(180)}
                color={time === 180 ? "green-inverse" : ""}
                className="text-center font-[700] cursor-pointer"
              >
                180 {t("Ngày")}
              </Tag>
              <Tag
                onClick={() => setTime(360)}
                color={time === 360 ? "green-inverse" : ""}
                className="text-center font-[700] cursor-pointer"
              >
                360 {t("Ngày")}
              </Tag>
            </div>
          </div>
          <div className="mb-3 ">
            <label className="text-[14px] mb-3">{t("Nhập số tiền đầu tư")}</label>
            <InputNumber
              placeholder={t("Nhập số tiền đầu tư")}
              min={packSelecteds?.min}
              max={packSelecteds?.max}
              className="w-full"
              value={amount}
              onChange={(value) => setAmount(value)}
            />
            <p className="mt-2 text-red-400">
              {t("Chú ý: Gói đầu tư chỉ từ")} {packSelecteds?.min}$ -{" "}
              {packSelecteds?.max}$
            </p>
          </div>
          <div className="mb-3 ">
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  setPoint_Type("auto");
                } else setPoint_Type("");
              }}
              className="text-[#fff]"
            >
              {t("Tự động gia hạn")}
            </Checkbox>
          </div>
          <div className="my-5">
           Balance: {formatNumber(user?.real_balance?.toFixed(3))} USDT
          </div>
          <div className="mb-3 flex justify-center">
            <button
              onClick={handleBuyInvest}
              className="mx-auto bit-button w-full md:w-1/2 bit-button--chunky bit-button--medium is-round"
            >
              {t("Đầu tư")}
            </button>
          </div>
        </div>
      </Modal>
      <div className="main-box lay-box clearfix">
        <div className="w-full bg-bg">
          <div className="flex items-center mb-5">
            <div className="items-left relative z-20 flex w-full flex-col justify-center">
              <div className="ipad:flex air:flex">
                <div className="w-full pc:max-w-[calc((1200px-384px))] ipad:max-w-[calc((100%-300px))] mobile:mt-0 mobile:max-w-[calc((100%-166px))]">
                  <h1 className="m-[0px]  text-[#fff] text-[20px] md:text-[40px] font-[700]">
                    {t("Đầu tư tự động")}
                  </h1>
                  <div className="m-[0px] mt-[16px] text-[#fff] text-[14px] md:text-[18px]">
                    {t("Kiếm thêm lợi nhuận bằng cách tự động đăng ký các sản phẩm đầu tư tự động")}
                  </div>
                </div>
              </div>
            </div>
            <img
              className="size-[100px] md:size-[400px]"
              alt="auto-invest-banner"
              src="https://www.bitget.com/earning/_next/static/media/banner.8d5faa1d.png"
            />
          </div>
          <div>
            <h3 className="font-[700] text-[#fff] text-[25px] mb-5">
              {t("Gói đầu tư")}
            </h3>
            <div className="flex flex-col gap-2">
              {data?.map((i: any) => (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border py-4 px-6 rounded-lg">
                  <div className="text-[16px] flex items-center md:items-start flex-col justify-center ">
                    <p className="font-[900] text-[#fff] text-[30px]">
                      {t("Gói")} {i?.id}
                    </p>
                    <p className="font-[900] text-[#fff]">
                      {i?.min}$ - {i?.max}$
                    </p>
                  </div>
                  <div className="font-[900] text-[#fff] flex flex-col items-center md:items-start">
                    {
                      i?.id === '1' && <p>7 {t("Ngày")} - {i?.rate?.["7d"]}%</p>
                    }

                    <p>30 {t("Ngày")} - {i?.rate?.["30d"]}%</p>
                    <p>90 {t("Ngày")} - {i?.rate?.["90d"]}%</p>
                    <p>180 {t("Ngày")} - {i?.rate?.["180d"]}%</p>
                    <p>360 {t("Ngày")} - {i?.rate?.["360d"]}%</p>
                  </div>
                  <div className="flex justify-center items-center">
                    <button
                      onClick={() => {
                        if (!user) return navigate("/login");
                        setOpen(true);
                        setPackSelected(i);
                        setTime(i?.id === '1' ? 7 : 30)
                      }}
                      className="bit-button w-full md:w-1/2 bit-button--chunky bit-button--medium is-round"
                    >
                      {t("Đầu tư")}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="my-6">
            <h3 className="font-[700] text-[#fff] text-[25px] mb-5">{t("Lịch sử")}</h3>
            <div className="flex items-center gap-4 ">
              <div
                className={clsx(
                  "text-[#fff] font-[900] cursor-pointer text-[18px]",
                  {
                    "border-b py-2": tabs === "INVEST",
                  }
                )}
                onClick={() => setTab("INVEST")}
              >
                {t("Lịch sử gói")}
              </div>
              <div
                className={clsx(
                  "text-[#fff] font-[900] cursor-pointer text-[18px]",
                  {
                    "border-b py-2": tabs === "INVEST_PROFIT",
                  }
                )}
                onClick={() => setTab("INVEST_PROFIT")}
              >
                {t("Lịch sử lợi nhuận")}
              </div>
              <div
                className={clsx(
                  "text-[#fff] font-[900] cursor-pointer text-[18px]",
                  {
                    "border-b py-2": tabs === "INVEST_PROFIT_REF",
                  }
                )}
                onClick={() => setTab("INVEST_PROFIT_REF")}
              >
                {t("Lịch sử hoa hồng giới thiệu")}
              </div>
            </div>
          </div>
          <div>
            {tabs === "INVEST" && (
              <div className="relative overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="px-6 py-3">
                        {t('Gói Mua')}
                      </th>
                      <th scope="col" className="px-6 py-3">
                        
                      </th>
                      <th scope="col" className="px-6 py-3">
                        {t("Ngày")} mua
                      </th>
                      <th scope="col" className="px-6 py-3">
                        {t("Ngày")} kết thúc
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {histories?.map((i: any) => (
                      <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          Gói {i?.bet_id}
                        </th>
                        <td className="px-6 py-4">
                          {formatNumber(i?.bet_value)}
                        </td>
                        <td className="px-6 py-4">
                          {new Date(i?.createdAt)?.toLocaleDateString()}
                        </td>
                        <td className="px-6 py-4">
                          {new Date(i?.time_end).toLocaleDateString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {tabs === "INVEST_PROFIT" && (
              <div className="relative overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="px-6 py-3">
                        {t("Ngày")} Nhận
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Số tiền đầu tư
                      </th>
                      <th scope="col" className="px-6 py-3">
                        % lợi nhuận
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Số tiền
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Gói nhận
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {histories?.map((i: any) => (
                      <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <td className="px-6 py-4">
                            {new Date(i?.createdAt)?.toLocaleDateString()}
                          </td>
                        </th>
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <td className="px-6 py-4">
                            {!i?.bet_value ? "-" : formatNumber(i?.bet_value)}
                          </td>
                        </th>
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <td className="px-6 py-4">
                            {!i?.commission_percent ? "-" : i?.commission_percent + "%"}
                          </td>
                        </th>
                        <td className="px-6 py-4">{formatNumber(i?.value)}</td>
                        <td className="px-6 py-4">Gói {i?.bet_id}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {tabs === "INVEST_PROFIT_REF" && (
              <div className="relative overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="px-6 py-3">
                        {t("Ngày")} Nhận
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Hoa hồng
                      </th>
                      <th scope="col" className="px-6 py-3">
                        % lợi nhuận
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Số tiền đầu tu
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Gói đầu tư
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Người mua
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {histories?.map((i: any) => (
                      <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <td className="px-6 py-4">
                            {new Date(i?.createdAt)?.toLocaleDateString()}
                          </td>
                        </th>
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <td className="px-6 py-4">
                            {!i?.value ? "-" : formatNumber(i?.value)}
                          </td>
                        </th>
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <td className="px-6 py-4">
                            {!i?.commission_percent ? "-" : i?.commission_percent * 100 + "%"}
                          </td>
                        </th>
                        <td className="px-6 py-4">{formatNumber(i?.bet_value)}</td>
                        <td className="px-6 py-4">Gói {i?.bet_id}</td>
                        <td className="px-6 py-4">{i?.note}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invest;
